import type {ComponentPropsWithoutRef, ReactNode} from 'react';
import {cn} from '@chekinapp/ui';

type Props = ComponentPropsWithoutRef<'h2'> & {
  icon?: ReactNode;
};

function SectionHeading({icon, className, children, ...props}: Props) {
  return (
    <h2
      className={cn(
        'text-[17px] font-semibold tracking-[-0.005em] text-[var(--chekin-color-brand-navy)]',
        icon &&
          'inline-flex items-center gap-2 [&>svg]:text-[var(--chekin-color-brand-blue)]',
        className,
      )}
      {...props}
    >
      {icon}
      {children}
    </h2>
  );
}

export {SectionHeading};
